export default "__VITE_ASSET__af5244b0__"